import Request from '@request'

export function getData(params) {
    return Request.post('/api/caa/v1/propaganda/getlistinfo', params)
}

